module.exports = __webpack_public_path__ + "static/Touchless_MonthTwo-29-57697f88ad156fd0b4bf815ce898929e.jpg";